document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('.site-header');
  const toggle=document.querySelector('[data-menu-toggle]');
  if(toggle&&header){toggle.addEventListener('click',()=>{const open=header.classList.toggle('is-open');toggle.setAttribute('aria-expanded',open?'true':'false')})}
  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const select=form.querySelector('[data-variant-select]');
    const price=form.querySelector('[data-product-price]');
    const button=form.querySelector('[name="add"]');
    if(!select)return;
    const update=()=>{const opt=select.options[select.selectedIndex];if(price&&opt.dataset.price)price.textContent=opt.dataset.price;if(button){const available=opt.dataset.available==='true';button.disabled=!available;button.textContent=available?(button.dataset.addText||'Add to cart'):(button.dataset.soldText||'Sold out')}};
    select.addEventListener('change',update);update();
  });
});